import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 md:py-24 bg-[#0A0E2A]" data-id="element-182">
      <div className="max-w-3xl mx-auto px-6" data-id="element-183">
        <FadeIn data-id="element-184">
          <div className="card-glass rounded-md p-10 md:p-14 text-center relative" style={{
          borderColor: 'rgba(201,168,76,0.4)'
        }} data-id="element-185">
            <div className="flex justify-center mb-8" data-id="element-186">
              <div className="relative" data-id="element-187">
                <div className="absolute inset-0 bg-gold-500/30 blur-2xl rounded-full" data-id="element-188"></div>
                <div className="relative w-24 h-24 rounded-full flex items-center justify-center bg-[#0d1530] border-2 border-gold-500" data-id="element-189">
                  <ShieldCheckIcon className="w-12 h-12 text-gold-400" strokeWidth={1.5} data-id="element-190" />
                </div>
              </div>
            </div>

            <p className="text-sm uppercase tracking-widest text-gold-400 mb-3 font-medium" data-id="element-191">
              Compra sin riesgo
            </p>
            <h2 className="text-3xl md:text-4xl font-serif mb-6 text-glow" data-id="element-192">
              Garantía Total de 30 Días
            </h2>
            <p className="text-body-xl text-cream-muted max-w-xl mx-auto leading-relaxed" data-id="element-193">
              Si en 30 días no duermes mejor, te devolvemos cada centavo. Sin
              preguntas. Sin complicaciones.
            </p>
            <p className="mt-6 text-gold-400 text-lg font-medium" data-id="element-194">
              El riesgo es 100% nuestro.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}